import React from "react";
import EditedTag from "../../pages/Documents/Components/EditedTag";

function EmployeExperienceSection({ eles }) {
  const { comparison } = eles?.element || {};

  console.log(comparison, "PPPPPPPPPPPPPPP");
  return (
    <div className="col-md-12">
      {eles?.element?.filledOnly >= 1 && (
        <div className="card p-2">
          <div className="row">
            <div className="col-12">
              <h6>Employment Tenure (Last Employer)</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2 relative">
                    <strong>
                      Current/Last Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_designation}
                    </div>
                    {comparison?.last_emp_designation && <EditedTag />}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Organization Name and Address
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_org}
                    </div>
                    {comparison?.last_emp_org && <EditedTag />}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment From Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_from_date}
                    </div>
                    {comparison?.last_emp_from_date && <EditedTag />}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment To Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_to_date}
                    </div>
                    {comparison?.last_emp_to_date && <EditedTag />}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Total years of experience
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_emp
                          ?.last_emp_year_of_experience
                      }
                    </div>
                    {comparison?.last_emp_year_of_experience && <EditedTag />}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Reason for Leaving
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_emp
                          ?.last_emp_reason_for_leaving
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Salary (per annum)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_salary}
                    </div>
                    {comparison?.last_emp_salary && <EditedTag />}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h6>Supervisor/ HR Manager Details</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Name
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {eles?.element?.value?.last_emp?.last_emp_supervisor_name}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_emp
                          ?.last_emp_supervisor_designation
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Mobile No.
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_emp
                          ?.last_emp_supervisor_mobile_no
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {eles?.element?.filledOnly >= 2 && (
        <div className="card p-2">
          <div className="row">
            <div className="col-12">
              <h6>Employment Tenure (Last to Last)</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Current/Last Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_designation
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Organization Name and Address
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_org
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment From Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_from_date
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment To Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_to_date
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Total years of experience
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_year_of_experience
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Reason for Leaving
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_reason_for_leaving
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Salary (per annum)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_salary
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h6>Supervisor/ HR Manager Details</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Name
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_supervisor_name
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_supervisor_designation
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Mobile No.
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_last_emp
                          ?.last_to_last_emp_supervisor_mobile_no
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {eles?.element?.filledOnly === 3 && (
        <div className="card p-2">
          <div className="row">
            <div className="col-12">
              <h6>Employment Tenure (Last to Second last)</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Current/Last Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_designation
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Organization Name and Address
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_org
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment From Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_from_date
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Employment To Date (dd/mm/yy)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_to_date
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Total years of experience
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_year_of_experience
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Reason for Leaving
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_reason_for_leaving
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Salary (per annum)
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_salary
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <h6>Supervisor/ HR Manager Details</h6>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Name
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_supervisor_name
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Designation
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_supervisor_designation
                      }
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card p-2">
                    <strong>
                      Mobile No.
                      <span style={{ color: "red" }}>
                        {eles?.element?.properties?.required ? "*" : ""}
                      </span>{" "}
                      :{" "}
                    </strong>
                    <div className="d-flex mt-1">
                      {
                        eles?.element?.value?.last_to_second_last_emp
                          ?.last_to_second_last_emp_supervisor_mobile_no
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeExperienceSection;
